import React, { Component } from 'react'
import classnames from 'classnames'
import Label from './label'
import FieldError from './fielderror'
import Help from './help'
import SubHelp from './subhelp'

/* eslint-disable react/prop-types */

export default class TextInput extends Component {
    static defaultProps = {
        error: null,
        help: null,
        initial: '',
        label: null,
        name: 'email',
        onKeyPress: () => {},
        placeholder: null,
        required: false,
        type: 'text',
        updateValue: () => {},
        updateValueOnBlur: false,
        value: '',
    }

    state = {
        value: this.props.value || '',
        showTooltip: false,
        tooltipPosition: null,
    }

    componentWillReceiveProps(nextProps) {
        // If the "value" change in props, we have to assume we need to "reset" this field's value.
        if (nextProps.value !== this.props.value) {
            this.setState({
                value: nextProps.value || '',
            })
        }
    }

    handleChange = (e) => {
        const value = e.target.value

        this.setState({ value })

        if (! this.props.updateValueOnBlur) {
            this.props.updateValue({ [this.props.name]: value })
        }
    }

    handleFocus = () => {
        const position = this.refs['form-control'].getBoundingClientRect()
        const tooltipPosition = position.height

        const newState = {
            showTooltip: true,
            tooltipPosition,
        }

        this.setState(newState)

        this.props.handleFocus && this.props.handleFocus()
    }

    handleBlur = () => {
        this.setState({
            showTooltip: false,
            tooltipPosition: null,
        })

        if (this.props.updateValueOnBlur) {
            this.props.updateValue({ [this.props.name]: this.state.value })
        }

        this.props.handleBlur && this.props.handleBlur()
    }

    render() {
        const value = this.state.value
        const inputId = `id_${ this.props.name }`

        const error = this.props.error

        const groupClasses = classnames({
            'form__group': true,
            'form__group--error': error,
            'form__group--required': this.props.required,
        })

        const controlClassDefinition = {
            'form__control': true,
            'form__control--text': true,
            'form__control--text-success': this.props.success,
            'form__control--text-error': error,
        }

        let field = null
        let helpUI = null

        if (this.props.type === 'textarea') {
            field = (
                <textarea
                    className="form__text form__textarea"
                    disabled={ this.props.disabled }
                    id={ inputId }
                    name={ this.props.name }
                    onBlur={ this.handleBlur }
                    onChange={ this.handleChange }
                    onFocus={ this.handleFocus }
                    onKeyPress={ this.props.onKeyPress }
                    placeholder={ this.props.placeholder }
                    ref="input"
                    required={ this.props.required }
                    rows={ this.props.rows }
                    type={ this.props.type }
                    value={ value }
                />
            )
        } else {
            if (this.props.prefix || this.props.suffix) {
                controlClassDefinition['form__control--input-group'] = true
            }

            field = []

            if (this.props.prefix) {
                field.push(
                    <div className="input-group__addon input-group__addon--prefix" key="prefix">
                        { this.props.prefix }
                    </div>
                )
            }

            field.push(
                <input
                    className="form__text"
                    disabled={ this.props.disabled }
                    id={ inputId }
                    key="field"
                    name={ this.props.name }
                    onBlur={ this.handleBlur }
                    onChange={ this.handleChange }
                    onFocus={ this.handleFocus }
                    onKeyPress={ this.props.onKeyPress }
                    placeholder={ this.props.placeholder }
                    ref="input"
                    required={ this.props.required }
                    type={ this.props.type }
                    value={ value }
                />
            )

            if (this.props.suffix) {
                field.push(
                    <div className="input-group__addon input-group__addon--suffix" key="suffix">
                        { this.props.suffix }
                    </div>
                )
            }
        }

        const controlClasses = classnames(controlClassDefinition)

        helpUI = (
            <Help help={ this.props.help }
                on={ this.state.showTooltip && ! this.props.error }
                position={ this.state.tooltipPosition }
            />
        )

        const errorText = this.props.error || null

        return (
            <div className={ groupClasses }>
                <Label htmlFor={ inputId }>
                    { this.props.label }
                </Label>
                <div className={ controlClasses } ref="form-control">
                    <FieldError
                        error={ errorText }
                        on={ this.state.showTooltip }
                        position={ this.state.tooltipPosition }
                    />
                    { field }
                    { helpUI }
                </div>
                <SubHelp help={ this.props.subHelp }/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/ui/textinput.js